import React from "react";
import { useState, useEffect } from "react";
import { RingLoader } from "react-spinners";
import { AiOutlineCheckCircle, AiFillHeart } from "react-icons/ai";
import { FaCopy, FaExchangeAlt } from "react-icons/fa";
import QRCode from 'qrcode.react';
import axios from "axios";
import { useLocation, Link } from 'react-router-dom';
import { alert_error, alert_success } from "../AppContext.js";

function Bill() {
  const location = useLocation();
  const [error, seterror] = useState(null);
  const [loading, setLoading] = useState(true);
  const [databill, setdatabill] = useState(true);
  const [domainok, setdomainok] = useState('https://hust.media/');
  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };
  const dulieubill = async () => {
    const pathName = location.pathname;
    setdomainok('https://hust.media' + pathName);
    console.log(pathName);
    const paramValue = pathName.split('/').pop();


    axios
      .get("https://hust.media/api/wallet/bill.php?idorder=" + paramValue)
      .then((response) => {
        console.log(response.data.data);
        if (response.data.status == true) {
          setdatabill(response.data.data);
        }
        else {
          seterror('Đã xảy ra lỗi Hust Media thật lòng xin lỗi');
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        seterror(error);
      });
  };
  useEffect(() => {
    setLoading(true);
    dulieubill();



  }, []);
  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center">
          <RingLoader size={80} color="#0000ff" loading={loading} />{" "}
        </div>
      ) : error ? (<div> {error}</div>) : (
        !loading && (
          <div className="mx-1">

            <div className="px-2  bg-pink-100 mt-3 p-2 rounded-lg shadow-md max-w-md mx-auto">
              <div className="flex items-center justify-center mb-0">
                <AiOutlineCheckCircle className="text-3xl text-pink-600 mr-2" />
                <h2 className="text-3xl font-bold text-pink-600">Hust Media</h2>
              </div>
              <div className="text-center">
                <p className="text-gray-800 text-sm mb-0">
                  Bạn đã chuyển tiền thành công
                </p>
                <p className="text-4xl mt-0 font-bold text-pink-600">{databill.money} VND</p>
              </div>
              <div className="flex rounded-xl bg-white p-2 shadow-lg">
                <AiFillHeart className="text-pink-600 text-4xl mr-2 mt-2" />

                <div className="ml-0">
                  <div className="mt-0 text-sm text-gray-500">Đến tài khoản </div>
                  <div className="mt-0 font-semibold">{databill.url} (ID: {databill.idnguoinhan})</div>
                </div>
              </div>
              <div className="mt-3 rounded-xl bg-white p-2 shadow-lg">
                <div className="grid grid-cols-2 gap-0">
                  <div className="text-pink-600 font-bold mb-1">Tài khoản nguồn</div>
                  <p className="mt-0 mb-1">{databill.username}</p>
                  <div className="text-pink-600 font-bold mb-1">Nội dung:</div>
                  <p className="mt-0 mb-1">{databill.note}</p>
                  <div className="text-pink-600 font-bold mb-1">Mã giao dịch:</div>
                  <p className="mt-0 mb-1">{databill.id}</p>
                  <div className="text-pink-600 font-bold mb-1">Thời gian:</div>
                  <p className="mt-0 mb-1">{databill.createdate}</p>
                </div>

                <div className="mt-1 flex items-center justify-center">

                  <QRCode size={100} value={domainok} />

                </div>
              </div>


              <div className="mt-4 flex justify-center">
                <button onClick={() => saochep(domainok)} className="flex items-center px-4 py-2 mr-2 bg-blue-500 text-white rounded-lg">
                  <FaCopy className="mr-2" />
                  Sao chép
                </button>
                <Link style={{ textDecoration: 'none' }} to="/shop/transfer_coins?showadview=true">   <button className="flex items-center px-4 py-2 bg-green-500 text-white rounded-lg">
                  <FaExchangeAlt className="mr-2" />
                  Tạo giao dịch khác
                </button> </Link>
              </div>



            </div>
          </div>
        )
      )}
    </>

  );
};

export default Bill;
